import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
    AppAlertService,
    AuthenticationService,
    SubtitlesService
} from "../core";
import {ForgotPasswordService} from "../core/forgot-password.service";
import {Subscription} from "rxjs";


@Component({
    selector: 'app-confirm-delete-account',
    templateUrl: './confirm-delete-account.component.html',
    styleUrls: ['./confirm-delete-account.component.scss']
})
export class ConfirmDeleteAccountComponent implements OnInit, OnDestroy {
    isRequesting = false;
    private subtitlesSubscription: Subscription;

    constructor(
        private http: HttpClient,
        private subtitles: SubtitlesService,
        private appAlert: AppAlertService,
        private authentication: AuthenticationService,
        private forgotPassword: ForgotPasswordService
    ) {
    }

    ngOnInit(): void {
        this.forgotPassword.getUrl();

        if (this.subtitles.downloaded) {
            this.deleteAccountConfirmAlert();
        } else {
            this.subtitlesSubscription = this.subtitles.subtitlesChanged$.subscribe((newValue) => {
                if (newValue && !this.isRequesting) {
                    this.deleteAccountConfirmAlert();
                }
            });
        }
    }

    ngOnDestroy() {
        if (this.subtitlesSubscription) {
            this.subtitlesSubscription.unsubscribe();
        }
    }

    deleteAccountConfirmAlert() {
        this.isRequesting = true;
        let confirmationCode = this.forgotPassword.url_id;
        if (!confirmationCode) {
            this.showError();
            return;
        }

        this.http.delete(`/api/v1/account/${confirmationCode}`)
            .subscribe({
                next: () => {
                    this.appAlert.showAppAlert(
                        this.subtitles.setSubtitle(8844),
                        this.subtitles.setSubtitle(475),
                        this.authentication.logout.bind(this.authentication),
                        false,
                        null
                    );
                },
                error: () => {
                    this.showError();
                }
            });
    }

    private showError() {
        this.appAlert.showAppAlert(
            `${this.subtitles.setSubtitle(4282)}, ${this.subtitles.setSubtitle(1136)}`,
            this.subtitles.setSubtitle(1136),
            this.authentication.logout.bind(this.authentication),
            false,
            null
        );
    }
}
